<template>
  <div>
    <ebCardOne>
      <div class="list-header">
        <div class="list-header-left ellipsis">
          <router-link
            v-if="user.roleid === '2' || user.roleid === '8' || user.roleid === '9' "
            :to="'/buyer/detail/'+ orgInfo.departId"
          >
            {{orgInfo.departName}}
          </router-link>
          <router-link
            v-else
            :to="'/supplier/detail/'+ orgInfo.departId"
          >
            {{orgInfo.departName}}
          </router-link>
          <ebFontType v-if="orgInfo.authStatus === '1'">
            <span>实</span>
          </ebFontType>
        </div>
        <div class="list-header-right">
          <span>分享</span>
          <i class="icon iconfont icon-fenxiang"></i>
          <span>关注</span>
          <i
            v-if="orgInfo.isFollow != '0'"
            @click="followCompany"
            class="icon iconfont icon-wujiaoxing"
          ></i>
          <i
            v-else
            @click="followCompany"
            class="icon iconfont icon-wujiaoxing-red"
          ></i>
        </div>
      </div>
      <div class="list-body">
        <div class="list-body-left">
          <template v-if="orgInfo.departLogo">
            <img :src="departLogoImgSrc">
          </template>
          <template v-else>
            <img :src="$ebConfig.imgPath+'img/project-default.jpg'">
          </template>
        </div>
        <div class="list-body-right">
          <div class="card-one-row">
            <div class="col-165-rw">
              <div class="col-left">注册资本:</div>
              <div class="col-right">
                <span class="col-right-content"> {{orgInfo.registerCapital}}</span>
              </div>
            </div>
            <div class="col-243-rw">
              <div
                class="col-left"
                style="width:55px"
              >联系人:</div>
              <div class="col-right">
                <template v-for="(item, $index) in orgInfo.contacts">
                  <template v-if="item.headImg">
                    <img
                      :key="$index"
                      @click="userInfoDialog(item.userId)"
                      class="header_img"
                      :src="headImgSrc(item.headImg)"
                    >
                  </template>
                  <template v-else>
                    <img
                      :key="$index"
                      @click="userInfoDialog(item.userId)"
                      class="header_img"
                      :src="$ebConfig.imgPath+'img/user-default.jpeg'"
                    >
                  </template>
                </template>
              </div>
            </div>
            <div class="col-165-rw">
              <div class="col-left">历史合作:</div>
              <div class="col-right">
                {{orgInfo.cooperationTimes}}
              </div>
            </div>
            <div class="col-261-rw">
              <div
                class="col-left"
                style="width:35px"
              >地址:</div>
              <div class="col-right">
                <span class="col-right-content"> {{orgInfo.registerAddress}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ebCardOne>
  </div>
</template>
<script>
import ebCardOne from '@/components/common/card/eb-card-one';
import ebFontType from '@/components/common/eb-font-type';
import eventBus from '@/plugins/event-bus';
import { followCompany } from '@/services/user/user-supplier-service';
import { baseURL } from '@/plugins/axios';
export default {
  props: {
    orgInfo: {
      type: Object
    },
    user: {}
  },
  components: {
    ebCardOne,
    ebFontType
  },
  methods: {
    userInfoDialog: function(userId) {
      eventBus.$emit('userInfoDialog', userId);
    },
    // 关注或取消关注
    async followCompany() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await followCompany(this.orgInfo.departId);
        if (data.returnCode === '01') {
          this.$message.success('操作成功');
          this.$emit('followSuccess');
        } else if (data.returnCode === '00') {
        } else {
          this.$message.error('操作失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    }
  },
  created() {
    this.$root.layout.isLoading = false;
  },
  computed: {
    headImgSrc() {
      return function(headImg) {
        return baseURL + headImg + '?time=' + Date.now();
      };
    },
    departLogoImgSrc: {
      cache: true,
      get: function() {
        return baseURL + this.orgInfo.departLogo + '?time=' + Date.now();
      }
    }
  }
};
</script>
<style scoped lang="less">
.list-header {
  display: flex;
  flex-wrap: wrap;
}
.list-header-left {
  height: 52px;
  width: 60%;
  line-height: 52px;
  a {
    color: #060606;
    font-weight: 700;
    font-family: 'Microsoft YaHei';
  }
}
.list-header-right {
  padding-top: 13px;
  width: 39%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  box-sizing: border-box;
  padding-right: 175px;
  i {
    color: #fb5b3b;
  }
}
.list-body {
  display: flex;
  flex-wrap: wrap;
}
.list-body-left {
  height: 60px;
  width: 13%;
  display: flex;
  img {
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.list-body-right {
  width: 86%;
  padding-left: 1%;
}
.header_img {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin-top: 8px;
  cursor: pointer;
}
.icon-wujiaoxing,
.icon-wujiaoxing-red {
  cursor: pointer;
}
</style>
